import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueJudgePageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        judge: {
          subtitle: "裁判台必须绑定具体演练活动后使用。",
          activitySubtitle: "演练活动 #{activityCode}",
          selectorNotice: "裁判台必须先绑定具体演练活动；当前列表用于选择待评分或待复核的活动。",
          alertTitle: "裁判台处理活动内报告、主观评分和待复核成绩；自由对抗的计分也在这里完成。",
          archivedReadonlyTitle: "该活动已归档，裁判台只保留历史只读查看。",
          archivedReadonlyDescription:
            "归档活动不再允许主观打分、待复核处理或最终成绩确认；如需审计，请改走态势与复盘或查看现有历史记录。",
          tabs: {
            pendingScores: "待复核成绩",
            reports: "报告评分",
            scores: "全部成绩",
          },
          actions: {
            confirmFinalScore: "确认最终成绩",
            confirmScore: "确认",
            rejectScore: "驳回",
          },
          confirm: {
            confirmScore: "确认这条成绩？",
            confirmScoreOk: "确认",
            rejectScore: "驳回这条成绩？",
            rejectScoreOk: "驳回",
            finalScore: "确认最终成绩？该动作会写入复盘记录。",
            finalScoreOk: "确认最终成绩",
          },
          success: {
            scoreConfirmed: "成绩已确认",
            scoreRejected: "成绩已驳回",
            finalScoreConfirmed: "最终成绩已确认",
            scoreSubmitted: "评分已提交",
          },
          scoreForm: {
            title: "主观打分",
            taskCodeLabel: "任务编码",
            userIdLabel: "用户 ID",
            scoreDeltaLabel: "分值变化",
            scoreDeltaRequired: "请输入分值",
            reasonLabel: "评分原因",
            reasonRequired: "请输入评分原因",
          },
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        judge: {
          subtitle: "Judge workspace requires a bound activity context.",
          activitySubtitle: "Activity #{activityCode}",
          selectorNotice:
            "Judge workspace must bind to an activity first. Use this list to choose an activity for scoring or review.",
          alertTitle:
            "Judge workspace handles activity reports, subjective scoring, and pending score reviews.",
          archivedReadonlyTitle:
            "This activity is archived, so the judge workspace is now read-only history.",
          archivedReadonlyDescription:
            "Archived activities no longer allow subjective scoring, pending-review decisions, or final-score confirmation. Use review or existing history records for audit.",
          tabs: {
            pendingScores: "Pending Review",
            reports: "Reports",
            scores: "All Scores",
          },
          actions: {
            confirmFinalScore: "Confirm Final Score",
            confirmScore: "Confirm",
            rejectScore: "Reject",
          },
          confirm: {
            confirmScore: "Confirm this score record?",
            confirmScoreOk: "Confirm",
            rejectScore: "Reject this score record?",
            rejectScoreOk: "Reject",
            finalScore: "Confirm the final score? This action will be written into review records.",
            finalScoreOk: "Confirm Final Score",
          },
          success: {
            scoreConfirmed: "Score confirmed",
            scoreRejected: "Score rejected",
            finalScoreConfirmed: "Final score confirmed",
            scoreSubmitted: "Score submitted",
          },
          scoreForm: {
            title: "Subjective Score",
            taskCodeLabel: "Task Code",
            userIdLabel: "User ID",
            scoreDeltaLabel: "Score Delta",
            scoreDeltaRequired: "Enter a score delta",
            reasonLabel: "Scoring Reason",
            reasonRequired: "Enter a scoring reason",
          },
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        judge: {
          subtitle: "ジャッジ画面は特定の演習活動に紐付けて使用します。",
          activitySubtitle: "演習活動 #{activityCode}",
          selectorNotice:
            "ジャッジ画面は先に演習活動へ紐付ける必要があります。この一覧から採点またはレビュー対象の活動を選択してください。",
          alertTitle: "ジャッジ画面は活動内レポート、主観採点、レビュー待ち採点を処理します。",
          archivedReadonlyTitle:
            "この活動はアーカイブ済みのため、ジャッジ画面は履歴の閲覧専用です。",
          archivedReadonlyDescription:
            "アーカイブ済み活動では主観採点、レビュー待ち処理、最終得点確定はできません。監査が必要な場合はレビュー画面または既存の履歴を参照してください。",
          tabs: {
            pendingScores: "レビュー待ち採点",
            reports: "レポート",
            scores: "全採点",
          },
          actions: {
            confirmFinalScore: "最終得点を確定",
            confirmScore: "確認",
            rejectScore: "却下",
          },
          confirm: {
            confirmScore: "この採点記録を確認しますか？",
            confirmScoreOk: "確認",
            rejectScore: "この採点記録を却下しますか？",
            rejectScoreOk: "却下",
            finalScore: "最終得点を確定しますか？この操作はレビュー記録へ書き込まれます。",
            finalScoreOk: "最終得点を確定",
          },
          success: {
            scoreConfirmed: "採点を確認しました",
            scoreRejected: "採点を却下しました",
            finalScoreConfirmed: "最終得点を確定しました",
            scoreSubmitted: "採点を送信しました",
          },
          scoreForm: {
            title: "主観採点",
            taskCodeLabel: "タスクコード",
            userIdLabel: "ユーザー ID",
            scoreDeltaLabel: "点数差分",
            scoreDeltaRequired: "点数差分を入力してください",
            reasonLabel: "採点理由",
            reasonRequired: "採点理由を入力してください",
          },
        },
      },
    },
  },
};
